function Invite() {
    return (
        <div className="login">
            <div className="wrapper">
                INVITE
            </div>
        </div>
    )
}

export default Invite;